export default __webpack_public_path__ + "static/media/5.22.9ea58149.mp3";